// 导入axios
import axios from "axios";
import { getHeader } from "./header";
import Config from "../config";
import ElementUI from "element-ui";
import router from "../router/index";

// 进行一些全局配置
// 公共路由(网络请求地址)
let baseURL = Config.baseUrl;
console.log("路径");
console.log(Config.baseUrl);
// 请求响应超时时间
let timeout = 60000;

const service = axios.create({
  baseURL: baseURL,
  timeout: timeout
});

service.interceptors.request.use(
  config => {
    let url = config.url.replace(config.baseURL, "");
    let code = config.code;
    config.headers = getHeader(url, code);
    return config;
  },
  error => {
    console.log(error);
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    // console.log(response);

    if (!response.data.success) {
      ElementUI.Message.error(response.data.msg);
    }
    if (response.data.errorCode == 2001) {
      ElementUI.Message.error(response.data.msg);
      console.log("Token失效跳转登录页面");
      sessionStorage.removeItem("userInfo");
      if (sessionStorage.getItem("examId")) {
        router.push("/apply");
      } else {
        router.push("/home");
      }
    }
    return response;
  },
  error => {
    console.log("err" + error);
    return Promise.reject(error);
  }
);

export default service;

// 封装自己的get/post方法
// export default {
//   get: function(path = '', data = {}) {
//     return new Promise(function(resolve, reject) {
//       axios.get(path, {
//         params: data
//       })
//         .then(function(response) {
//           // 按需求来，这里我需要的是response.data，所以返回response.data，一般直接返回response
//           resolve(response);
//         })
//         .catch(function(error) {
//           reject(error);
//         });
//     });
//   },
//   post: function(path = '', data = {}) {
//     return new Promise(function(resolve, reject) {
//       axios.post(path, data)
//         .then(function(response) {
//           resolve(response.data);
//         })
//         .catch(function(error) {
//           reject(error);
//         });
//     });
//   }
// };



// WEBPACK FOOTER //
// ./src/api/axios.js